<template>
  <div id="error-page" class="container-fluid container h-100">

    <error-group :title="$t('adm.error.title')" :message="$t('adm.error.generic')" v-if="!status" />

    <error-group
      :title="$t('adm.error.title403')"
      :message="$t('adm.error.403', [myDisplayName])"
      v-if="status === 403">
      <a class="link" @click="logout" @keyup.enter="logout" v-if="principal">{{ $t('adm.button.logout') }}</a>
    </error-group>

  </div>
</template>

<script lang="ts">
import ErrorGroup from '@/components/ui/ErrorGroup.vue';
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import useAppStore from '@/components/store';
import { AdminRole } from '@/components/backend';
import userManager from '@/components/oidc';

export default defineComponent({
  name: 'GenericError',
  components: { ErrorGroup },
  props: {
    status: { type: Number, default: null },
  },
  computed: {
    ...mapState(useAppStore, {
      principal: 'principal',
      myDisplayName: 'myDisplayName',
      myRole: 'getMyAdminRole',
    }),
    userManager() {
      return userManager;
    },
  },
  methods: {
    roleDisplayName(role?: AdminRole) {
      return this.$t(`adm.label.adminRoles.${role || 'none'}`);
    },
    logout() { userManager.signoutRedirect(); },
  },
});
</script>
